import * as amplitude from '@amplitude/analytics-browser';
import type { App } from 'vue';
import { markRaw } from 'vue';

import type { Locale } from '@/config/build';
import type { Environment } from '@/plugins/request/types/index';

import Avo, { AvoEnv } from './Avo';
import amplitudeDestinationInterface from './destinations/amplitude';
import { PLUGIN_KEY } from './providers';

interface PluginConfig {
  env: Environment;
  locale?: Locale;
}

export const ENV = {
  production: 'production',
  development: 'development',
  testing: 'testing',
} as const;

export function createAvoPlugin(config: PluginConfig) {
  const init = () => {
    Avo.initAvo(
      {
        env: config.env === ENV.production ? AvoEnv.Prod : AvoEnv.Dev,
        webDebugger: false,
      },
      {
        eventSource: 'web',
        dpSource: 'noa hub',
        screenHeigth: window.innerHeight,
        screenWidth: window.innerWidth,
      },
      {},
      amplitudeDestinationInterface,
    );
  };

  return markRaw({
    ...Avo,

    flushAmplitude: () => amplitude.flush(),

    install(app: App) {
      app.config.globalProperties['$avo'] = this;
      app.provide(PLUGIN_KEY, this);
      init();
    },
  });
}
